<template>
    <div class="form-wrap">
      <div>
        <label for="name">Name</label>
        <input
          type="text"
          id="name"
          placeholder="Name"
          v-model="$parent.admin_user.name"
        />
      </div>

      <div>
        <label for="email">Email</label>
        <input id="email" type="email" v-model="$parent.admin_user.email" placeholder="Email"/>
      </div>

      <div>
          <label for="role"> Role </label>
          <v-select
                  id="role"
                  label="name"
                  index="id"
                  placeholder="Select Role"
                  :options="[
                    {
                        id: 1,
                        name:'Admin'
                    },
                    {
                        id: 2,
                        name:'Accountant'
                    },
                  ]"
                  v-model="$parent.admin_user.role"
              />
      </div>
      <div>
        <label for="phone">Login password</label>
        <input type="text" id="phone" v-model="$parent.admin_user.login_password" placeholder="Login Password"/>
      </div>

    </div>
</template>

<script>
    export default {
        name: 'AdminUserFields'
    }
</script>

<style lang="scss" scoped>

</style>